<template>
  <div>
    <a-drawer :width="1360" :visible="visible" :mask-closable="true" :ok-button-props="{ props: { loading: loading } }" :body-style="{ paddingBottom: '80px' }" @close="close" @ok="onSubmit">
      <template slot="title">
        <span> 业务需求详情 </span>
      </template>
      <Detail ref="detailRef" />
    </a-drawer>
  </div>
</template>

<script>
import Detail from '@/pages/business/requirement/Detail';
export default {
  components: { Detail },
  data() {
    return {
      visible: false,
      loading: false
    };
  },
  methods: {
    open(record) {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.detailRef.init(record);
      });
    },
    close() {
      this.visible = false;
    },
    onSubmit() {}
  }
};
</script>

<style lang="less" scoped></style>
